import { rootStore } from '../mobx/rootStore';
import LocalDbService, { PROJECTS_TABLE_NAME_MOBX, UPDATE_ON_ID } from './localDbService';
import { RawProject } from '../mobx/interfaces/project';

let singleton: MobxProjectsCacheService | null = null;
let organizationId: string | null = null;

export default class MobxProjectsCacheService extends LocalDbService {
  constructor(props: any) {
    const db_name = `${props.organizationId}`;
    props.dbName = db_name;
    props.tableName = PROJECTS_TABLE_NAME_MOBX;
    organizationId = props.organizationId;
    super(props);
  }

  static getInstance() {
    const workspaceId = rootStore.workspaceStore.currentWorkspace?.id || 'Unknown';
    if (!singleton || organizationId !== workspaceId) {
      singleton = new MobxProjectsCacheService({ organizationId: workspaceId });
    }
    return singleton;
  }

  static removeInstance() {
    if (singleton) singleton.closeDb();
    organizationId = null;
    singleton = null;
  }

  async getProjects() {
    const projects = await this.getDb().toArray();
    return projects as RawProject[];
  }

  async setProjects(projects: RawProject[]) {
    return await this.getDb().bulkPut(projects);
  }

  async updateProject(projectId: string, changes: Partial<RawProject>) {
    return await this.getDb().update(projectId, changes);
  }

  async getProjectsByIds(projectIds: string[]) {
    const projects = (await this.getDb().bulkGet(projectIds)).filter((project: any) => !!project);
    return projects as RawProject[];
  }

  async removeBulk(projectIds: string[]) {
    await this.getDb().bulkDelete(projectIds);
  }

  async getLastUpdatedTime() {
    try {
      const result = await super.getLastUpdatedTime(`MOBX_${UPDATE_ON_ID.PROJECT}_${organizationId}`);
      if (result === 0 || new Date(result).toString() === 'Invalid Date') {
        return null;
      }
      return new Date(result);
    } catch (err) {
      return null;
    }
  }

  async updateLastUpdatedTime() {
    const result = await super.setLastUpdatedTime(
      `MOBX_${UPDATE_ON_ID.PROJECT}_${organizationId}`,
      new Date().toUTCString()
    );
    return result;
  }
}
